import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Navbar, Nav, NavDropdown, Container, Form, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import LanguageSelector from "./LanguageSelector/LanguageSelector";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import API_URLS from './apiConfig';

const NavbarComponent = () => {
  const [searchVisible, setSearchVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // Tracks visibility of the navbar
  const [menuData, setMenuData] = useState([]);
  const searchRef = useRef(null);
  const prevScrollY = useRef(0);
  const imageUrl=API_URLS.baseUrl;
  const homeUrl=API_URLS.baseFrontUrl;
  const homedefaultDirectory=API_URLS.defaultDirectory;


  // State to manage hover visibility of dropdowns
  const [showDropdowns, setShowDropdowns] = useState({});

  // Function to handle mouse enter
  const handleMouseEnter = (index) => {
    setShowDropdowns((prevState) => ({ ...prevState, [index]: true }));
  };

  // Function to handle mouse leave
  const handleMouseLeave = (index) => {
    setShowDropdowns((prevState) => ({ ...prevState, [index]: false }));
  };

  useEffect(() => {
    axios
      .get(API_URLS.getMenu)
      .then((response) => {
        if (response.data.success) {
          setMenuData(response.data.data.menu_data);
        }
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });
  }, []);

  // Hide/show navbar based on scroll direction
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY =
        window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0; // iOS compatibility

      if (currentScrollY === 0) {
        // Ensure navbar is visible when at the top
        setIsVisible(true);
      } else if (currentScrollY > prevScrollY.current) {
        // Scrolling down, hide navbar
        setIsVisible(false);
      } else {
        // Scrolling up, show navbar
        setIsVisible(true);
      }

      prevScrollY.current = currentScrollY;

      // Dynamically load the Spline viewer script
      const script = document.createElement("script");
      script.type = "module";
      script.src = "https://unpkg.com/@splinetool/viewer@1.9.54/build/spline-viewer.js";
      document.body.appendChild(script);

      return () => {
        // Cleanup the script on component unmount
        if (script && document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  

  // Close search on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Navbar
      className={`navbar-component ${isVisible ? "navbar-visible" : "navbar-hidden"}`}
      expand="lg"
      variant="dark"
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand className="logo me-auto">
          <Link to={homeUrl} className="text-decoration-none">
            <img 
              src={imageUrl+'logo_basic.png'} 
              alt="Logo" 
              style={{ width: "100px", height: "100%", }} />
          </Link>
        </Navbar.Brand>

        {/* Navbar Toggle for Mobile */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        {/* Navbar Links */}
        <Navbar.Collapse id="navbar-nav">
          <Nav className="mx-auto">
            {menuData.map((menuItem, index) => (
              <React.Fragment key={`menu-item-${index}`}>
                {Array.isArray(menuItem.children) && menuItem.children.length === 0 ? (
                  <Nav.Link 
                    as={Link} 
                    to={homeUrl + menuItem.url} 
                    className="custom-nav-link"
                  >
                    {menuItem.title}
                  </Nav.Link>
                ) : (
                  <NavDropdown
                    title={menuItem.title}
                    id={`nav-dropdown-${index}`}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={() => handleMouseLeave(index)}
                    show={showDropdowns[index]}
                    className="custom-nav-link"
                  >
                    <div className="navdropdown-innerdiv container">
                      {menuItem.children.map((menuItemChild, childIndex) => (
                        <React.Fragment key={`child-${index}-${childIndex}`}>
                          {Array.isArray(menuItemChild.children) && menuItemChild.children.length === 0 ? (
                            <a 
                              href={homeUrl + menuItemChild.url} 
                              className="dropdown-item custom-dropdown-item"
                            >
                              {menuItemChild.title}
                            </a>
                          ) : (
                            <div className="mega-menu" key={`mega-${index}-${childIndex}`}>
                              <h5 className="nav-header-link">{menuItemChild.title}</h5><br/>
                              <div className="megamenuinner row">
                                {menuItemChild.children.map((menuItemSecondChild, secondChildIndex) => (
                                  <div 
                                    key={`second-${index}-${childIndex}-${secondChildIndex}`} 
                                    className={`mega-menu-column col-md-4 ${Array.isArray(menuItemSecondChild.children) && menuItemSecondChild.children.length === 0 ? 'industries-ul' : ''}`}
                                  >
                                    {Array.isArray(menuItemSecondChild.children) && menuItemSecondChild.children.length === 0 ? (
                                      <div>
                                        <a href={homeUrl + menuItemSecondChild.url + "#section-" + (secondChildIndex + 1)}>
                                          {menuItemSecondChild.title}
                                        </a>
                                      </div>
                                    ) : (
                                      <>
                                        <h6>
                                          <span>
                                            <a 
                                              href={homeUrl + menuItemSecondChild.url} 
                                              className="headerlink"
                                            >
                                              {menuItemSecondChild.title}
                                            </a>
                                            <div className="line"></div>
                                          </span>
                                        </h6>
                                        <ul>
                                          {menuItemSecondChild.children.map((menuItemThirdChild, thirdChildIndex) => (
                                            <li key={`third-${index}-${childIndex}-${secondChildIndex}-${thirdChildIndex}`}>
                                              <a href={homeUrl + menuItemThirdChild.url}>
                                                {menuItemThirdChild.title}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </>
                                    )}
                                  </div>
                                ))}
                              </div>
                              <hr/>
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </NavDropdown>
                )}
              </React.Fragment>
            ))}
          </Nav>

          {/* Right Side: GenAssistant, Search, Language Selector */}
          <div className="d-flex align-items-center">
            <div ref={searchRef} className="search-icon-container ms-3">
              <Link to='/search'>
                <FaSearch
                  size={20}
                  className="search-icon"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
            <LanguageSelector />
          </div>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default NavbarComponent;